import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus";
import ModalControls from "../../common/ModalControls";
import { useNavigate, useLocation } from "react-router-dom";
import { defaultFormState } from "../../../../defaults/Forms";
import { nfzBranchDefault } from "../../../../defaults/Items";
import {
  onSaveAndClose,
  compareData,
  restoreFormData,
  onItemsListDeleteButtonClick,
  onCloseDetails, setForegroundColor
} from "../../../../helpers/ComponentHelper";

import AppComponentCardHeader from "../../common/AppComponentCardHeader";
import LoadingDataDiv from "../../common/LoadingDataDiv";
import DeleteWarningModal from "../../common/DeleteWarningModal";
import SettingsEntityModal from "../../common/SettingsEntityModal";
import ItemDetailsModalHeader from "../../common/ItemDetailsModalHeader";
import TextInput from "../../../elements/TextInput";
import TextArea from "../../../elements/TextArea";
import useCrud from "../../../../hooks/useCrud";
import { Table } from "../../../table/Table";

import { MDBDataTableV5 } from "mdbreact";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";

const NfzBranch = () => {

  const dataUrl ="/nfz-branches";
  const relatedItemsUrl = null; // if no need to check it, initialize with null and remove RelatedItemsList from details modal
  const defaultItem = nfzBranchDefault;
  const itemName = "oddział NFZ";
  const itemNames = "oddziały NFZ";
  const navigate = useNavigate();
  const location = useLocation();
  const {createItem, updateItem, deleteItem, getItems, getRelatedChildrenByParentId} = useCrud(dataUrl);

  const [loading, setLoading] = useState(true);
  const [allowDelete, setAllowDelete] = useState(null);
  const [currentFormState, setCurrentFormState] = useState(defaultFormState);
  const [itemsList, setItems] = useState([]);
  const [currentItem, setCurrentItem] = useState(defaultItem);
  const [backupItem, setBackupItem] = useState(defaultItem);
  const [itemChanged, setItemChanged] = useState(false);
  const [updateConflict, setUpdateConflict] = useState(false);


  // elements related to the item
  const columns = [
    {label: "Id", accessor: "id", sortable: true, searchable: false},
    {label: "Nazwa", accessor: "name", sortable: true, searchable: true},
    {label: "Identyfikator", accessor: "identifier", sortable: true, searchable: true},
    {label: "Edycja", accessor: "editBtn", sortable: false, searchable: false},
    {label: "Usuń", accessor: "deleteBtn", sortable: false, searchable: false},
  ];


  const state = {
    itemsList, setItems,
    currentItem, setCurrentItem,
    currentFormState, setCurrentFormState,
    defaultItem, backupItem, setBackupItem, itemChanged, setItemChanged,
    setAllowDelete,
    setRelatedItems: null
  }


  const onDelete = async () => {
    const response = await deleteItem(`${dataUrl}/${currentItem.id}`, currentItem.id, state);
    if (response === 401 || response === 403) {
      navigate('/login', {state: {from: location}, replace: true});
    }
  }


  const onSaveItemClick = async (e) => {
    e.preventDefault();
    if (!currentItem.name || !currentItem.identifier) {
      if (!currentItem.name) {
        let nameInput = document.getElementById("name");
        nameInput.classList.add("form-input-invalid");
        nameInput.placeholder = `ten element jest wymagany`;
      }

      if (!currentItem.identifier) {
        let identifierInput = document.getElementById("identifier");
        identifierInput.classList.add("form-input-invalid");
        identifierInput.placeholder = `ten element jest wymagany`;
      }
      return;
    }

    let response;
    const item = {
      id: currentItem.id,
      identifier: currentItem.identifier,
      name: currentItem.name,
      description: currentItem.description
    };
    if (currentFormState.formAddingDataMode) {
      response = await createItem(dataUrl, item, state);
    } else {
      response = await updateItem(`${dataUrl}/${item.id}`, item, state);
    }

    if (response.status === 401 || response.status === 403) {
      navigate('/login', {state: {from: location}, replace: true});
    } else if (response.status === 409) {
      setUpdateConflict(true);

    } else {
      response && onSaveAndClose({state});
    }
  }

  const checkRelatedItems = async (id) => {
    //const data = await getRelatedChildrenByParentId(`${ relatedItemsUrl }/${ id }`, id, setEventsList);
    //data.length === 0 ? setAllowDelete(true) : setAllowDelete(false);
    setAllowDelete(true);
  }

  const onClose = () => {
    setUpdateConflict(false);
    onCloseDetails({state});
  };

  useEffect(() => {
    if (updateConflict) setUpdateConflict(false);
    compareData(currentFormState, setCurrentFormState, currentItem, backupItem);
  }, [itemChanged])

  useEffect(() => {
    if (allowDelete !== null) {
      onItemsListDeleteButtonClick(currentFormState, setCurrentFormState, itemName, allowDelete, currentItem.name);
    }
  }, [allowDelete])

  useEffect(() => {
    const getData = async () => {
      const response = await getItems(dataUrl);
      if (response.status === 200) {
        setLoading(false);
        setItems(response.data);
      } else if (response.status === 401 || response.status === 403) {
        navigate('/login', {state: {from: location}, replace: true})
      } else {
        alert("Nie udało się pobrać danych.");
      }
    };
    getData();
  }, [])


  const getCompleteItem = async (id) => {
    const response = await getItems(`${dataUrl}/${id}`);
    if (response.status === 200) {
      return response.data;
    } else if (response.status === 401 || response.status === 403) {
      navigate('/login', {state: {from: location}, replace: true})
    } else {
      alert("Nie udało się pobrać danych.");
    }
  }


  const addDataButtonProps = {
    setCurrentItem,
    setBackupItem,
    defaultItem,
    currentFormState,
    setCurrentFormState,
    formDescription: `Tu możesz dodać nowy element.`,
    formHeader: `Nowy element`,
    buttonTitle: ` Dodaj nowy oddział NFZ`
  }


  let dataSectionContent;
  if (loading) {
    dataSectionContent = <LoadingDataDiv/>
  } else if (itemsList.length > 0) {
    dataSectionContent =
      <Table
        rows={itemsList}
        columns={columns}
        state={state}
        checkRelatedItems={checkRelatedItems}
        formHeader={`Edycja ${itemName}`}
        relatedItemsUrl={relatedItemsUrl}
        getCompleteItem={getCompleteItem}
      />
  } else {
    dataSectionContent =
      <div className={"warn_info"}><FontAwesomeIcon
        className={"warning-icon div-visible"} icon={faExclamationCircle}/>&nbsp;&nbsp;&nbsp;NIE ZNALEZIONO ŻADNYCH DANYCH</div>
  }
  return (
    <div id="layoutSidenav_content" className="settings-entity-page">
      <AppComponentCardHeader title="Oddziały NFZ" buttonProps={addDataButtonProps}/>

      <div className="container-fluid px-4 py-3">
        <div className={itemsList.length > 0 ? "card shadow p-1 mb-5 bg-white rounded-2" : "card shadow mb-5 bg-transparent rounded-2"}>
          {dataSectionContent}
        </div>
      </div>

      <SettingsEntityModal
        show={currentFormState.showForm}
        onClose={onClose}
        title={currentFormState.formAddingDataMode ? "Nowa pozycja: Oddział NFZ" : `Edycja: ${currentItem.name || "Oddział NFZ"}`}
        adding={currentFormState.formAddingDataMode}
        introText="Lista oddziałów NFZ jest wykorzystywana w danych pracowników."
        onRestore={() => { setUpdateConflict(false); restoreFormData({state}); }}
        onDelete={onDelete}
        onSubmit={onSaveItemClick}
        state={state}
        size="sm"
      >
        <form id="add-nfz-branch-form" name="add-nfz-branch-form" className="settings-form-content-card">
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="row">
                                    <div className="col-md-12">
                                      <div className="md-form mb-0">
                                        <label htmlFor="name" className="">Nazwa *</label>
                                        <TextInput propertyName="name" required={true} state={state}/>
                                      </div>
                                    </div>
                                    <div className="col-md-12">
                                      <div className="md-form mb-0">
                                        <label htmlFor="identifier" className="">Skrót *</label>
                                        <TextInput propertyName="identifier" maxlen="10" required={true} state={state}/>
                                      </div>
                                    </div>
                                    <div className="col-md-12">
                                      <div className="md-form mb-0">
                                        <label htmlFor="description" className="">Opis</label>
                                        <TextArea propertyName="description" required={false} rows="2" state={state}/>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <p id="conflict_notification" className={updateConflict ? "err_info" : "offscreen"}>
                                <FontAwesomeIcon icon={faInfoCircle} />&nbsp;
                                Nie można dodać ani zmienić tego elementu, ponieważ istnieje już wpis o tej nazwie i/lub skrócie
                              </p>
                            </form>
      </SettingsEntityModal>

      <DeleteWarningModal state={state} onDelete={onDelete} deleteItemName={itemName}/>
    </div>
  );
}

export default NfzBranch;
